/* ══════════════════════════════════════════════════════════════════
   Die Wahl der Wiedervorlage am Telefon (`masken/handy/Notiz.tsx`).

   **Heute geht** (03.10.2026, Playbook M-05). Bis dahin begann die
   Schnellwahl bei „in 3 Tagen", und im Kalender war der früheste Tag
   morgen — wer einen Rückruf für heute Nachmittag festhalten wollte,
   konnte es nicht. Die API nimmt heute bis heute + 365 an
   (`routen/wiedervorlagen.ts`, `faelligAmPruefen`; Kundennotiz
   `wiedervorlage_tage` 0 bis 365); die Maske jetzt auch.
   ══════════════════════════════════════════════════════════════════ */

/** Die Fristen der Schnellwahl in Tagen ab heute — heute zuerst. */
export const SCHNELLWAHL = [0, 3, 7, 14] as const;

/** Weiter voraus nimmt die Route keine Wiedervorlage an. */
export const HOECHSTENS_TAGE = 365;

/** Der früheste Tag im Kalender: heute, nicht morgen. */
export const fruehesterTag = (heute: string): string => heute;

/** Tage von `heute` bis `tag` (beide `JJJJ-MM-TT`), gekappt auf 0 … 365. */
export function tageBis(heute: string, tag: string): number {
  const ms = Date.parse(`${tag}T12:00:00Z`) - Date.parse(`${heute}T12:00:00Z`);
  return Math.min(HOECHSTENS_TAGE, Math.max(0, Math.round(ms / 86_400_000)));
}
